import Head from 'next/head';

import { CatalogSearchResults } from '~/features/catalog/models/catalog-search-result';

import { createCatalogStructuredData } from '../utils/create-catalog-structured-data';

export function CatalogStructuredData({ catalogSearchResults }: { catalogSearchResults?: CatalogSearchResults }) {
  if (!catalogSearchResults) return null;
  const structuredData = createCatalogStructuredData(catalogSearchResults);
  return (
    <Head>
      <script
        key='structured-data-catalog'
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        type='application/ld+json'
      />
    </Head>
  );
}
